import { axios } from '@ori/axios';

import type { NovageSkincareConfiguration } from '../models';
import { ApiError } from '../models';
import { HEADERS } from './constants';
import type {
  GetNovageSkincareConfigurationProps,
  GetNovageSkincareConfigurationResponse,
} from './types';

export const getNovageSkincareConfiguration = async ({
  currentLanguage,
  staticApiUrl,
  tenant,
}: GetNovageSkincareConfigurationProps): Promise<NovageSkincareConfiguration> => {
  const url = new URL(staticApiUrl);
  url.pathname = `/tenants/${tenant}/applications/advisor/novAgeSkincareConfiguration`;
  try {
    const { data } = await axios.get<GetNovageSkincareConfigurationResponse>(url.toString(), {
      headers: HEADERS,
      params: { lang: currentLanguage },
    });

    return { env: data.Environment, partnerId: data.PartnerId };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new ApiError(error.message, error);
    }
    throw error;
  }
};
